import { __assign } from "tslib";
import React from "react";
import { Box } from "@material-ui/core";
import { Jpeg, Pdf, Ppt } from "./icons";
import { FileUploadedSize, FileUploadedText, MediaUploadHeading, useFilesUploadedStyles } from "./styles";
var computeBytes = function (x) {
    var units = ["bytes", "KB", "MB", "GB"];
    var l = 0;
    var n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
        n = n / 1024;
    }
    return "".concat(n.toFixed(n < 10 && l > 0 ? 1 : 0), " ").concat(units[l]);
};
var getIcon = function (type) {
    var iconType = type.split("/")[1];
    switch (iconType) {
        case "jpeg":
            return React.createElement(Jpeg, null);
        case "jpg":
            return React.createElement(Jpeg, null);
        case "pdf":
            return React.createElement(Pdf, null);
        case "vnd.ms-powerpoint":
            return React.createElement(Ppt, null);
        case "vnd.openxmlformats-officedocument.presentationml.presentation":
            return React.createElement(Ppt, null);
        default:
            return;
    }
};
export var FilesUploaded = function (_a) {
    var onClick = _a.onClick, attachments = _a.attachments, IconSvg = _a.IconSvg, _b = _a.showTitle, showTitle = _b === void 0 ? true : _b, _c = _a.borderColor, borderColor = _c === void 0 ? "hsl(225,34%,20%)" : _c, filenameColor = _a.filenameColor, _d = _a.isDownload, isDownload = _d === void 0 ? false : _d;
    var classes = useFilesUploadedStyles({ borderColor: borderColor, isDownload: isDownload });
    return (React.createElement(React.Fragment, null,
        React.createElement(MediaUploadHeading, null, showTitle && "FILES UPLOADED"),
        attachments.length !== 0 &&
            attachments.map(function (attachment) { return (React.createElement(Box, __assign({ className: classes.fileUploaded, key: attachment.id }, (isDownload && { onClick: function () { return onClick && onClick(attachment); } })),
                React.createElement(Box, { className: "container" },
                    React.createElement(Box, null, getIcon(attachment.fileType)),
                    React.createElement(Box, { className: classes.subContainer },
                        React.createElement(Box, { ml: 1 },
                            React.createElement(FileUploadedText, { color: filenameColor }, attachment.name),
                            React.createElement(FileUploadedSize, null, computeBytes(attachment.fileSizeInBytes)))),
                    React.createElement(Box, null, IconSvg && (React.createElement(IconSvg, __assign({ className: classes.icon }, (!isDownload && { onClick: function () { return onClick && onClick(attachment); } })))))))); })));
};
//# sourceMappingURL=FilesUploaded.js.map